import {
  Alert,
  AppShell,
  Card,
  Center,
  Flex,
  Loader,
  Pagination,
  ScrollArea,
  Space,
  Table,
  Text,
  Title
} from '@mantine/core';
import { useState } from 'react';

import { useGetAllActivityesListQuery } from '@/features/admin-panel/api/getAllActivitiesList/hook';

// Маппинг типов активности на русские описания
const activityTypeLabels: Record<string, string> = {
  NewArtistRegistered: 'Новый артист зарегистрирован',
  ArtistCreatedNewConversation: 'Артист создал новый чат',
  ArtistCreatedWorkRequest: 'Артист создал заявку',
  ArtistUpdatedWorkRequest: 'Артист обновил заявку',
  ArtistAcceptedWorkInvite: 'Артист принял приглашение',
  ArtistUpdatedWorkInvite: 'Артист обновил приглашение',
  ArtistCancelledAgreement: 'Артист отменил соглашение',
  ArtistRejectedWorkInvite: 'Артист отклонил приглашение',
  ArtistRequestedEndDate: 'Артист запросил дату окончания',
  ClubCreatedNewProfile: 'Клуб создал новый профиль',
  ClubCreatedWorkInvite: 'Клуб создал приглашение',
  ClubUpdatedWorkInvite: 'Клуб обновил приглашение',
  ClubAcceptedWorkRequest: 'Клуб принял заявку',
  ClubRejectedWorkRequest: 'Клуб отклонил заявку',
  ClubCancelledAgreement: 'Клуб отменил соглашение',
  ClubConfirmedArrival: 'Клуб подтвердил прибытие',
  ClubSetNewEndDate: 'Клуб установил новую дату окончания',
  ContractOngoing: 'Контракт в процессе',
  ContractCompleted: 'Контракт завершён',
  WorkRequestExpired: 'Срок действия заявки истёк',
  WorkInviteExpired: 'Срок действия приглашения истёк',
  AssistanceRequested: 'Запрошена помощь',
  ArtistWithdrewWorkRequest: 'Артист отозвал заявку',
  ArtistDeletedWorkRequest: 'Артист удалил заявку',
  ClubDeletedWorkRequest: 'Клуб удалил заявку',
  ClubUpdatedWorkRequest: 'Клуб обновил заявку',
  ArtistDeletedWorkInvite: 'Артист удалил приглашение',
  ClubDeletedWorkInvite: 'Клуб удалил приглашение',
  ClubWithdrewWorkInvite: 'Клуб отозвал приглашение',
  ClubCreatedNewConversation: 'Клуб создал новый чат',
  SecurityCodeSent: 'Отправлен код безопасности',
  NewClubownerRegistered: 'Зарегистрирован новый владелец клуба',
  NewUserRegistered: 'Зарег. новый пользователь'
};

export const GlobalEventsPage = () => {
  const [page, setPage] = useState(1);

  const { data, isLoading, isError } = useGetAllActivityesListQuery({
    pageNumber: page.toString()
  });

  if (isLoading) {
    return (
      <Center style={{ height: 200 }}>
        <Loader />
      </Center>
    );
  }

  if (isError) {
    return (
      <Alert color='red' mb='md' title='Ошибка'>
        Не удалось загрузить события.
      </Alert>
    );
  }

  const rows = data?.data.items.map((element) => (
    <Table.Tr key={element.userActivityId}>
      <Table.Td>{element.userActivityId ?? '-'}</Table.Td>
      <Table.Td>
        {activityTypeLabels[element.type] ?? element.type ?? '-'}
      </Table.Td>
      <Table.Td>
        {element.timestamp ? new Date(element.timestamp).toLocaleString() : '-'}
      </Table.Td>
      <Table.Td>
        {element.artistName ?? '-'} ({element.artistProfileId ?? '-'})
      </Table.Td>
      <Table.Td>
        {element.clubName ?? '-'} ({element.clubProfileId ?? '-'})
      </Table.Td>
      <Table.Td>{element.workInviteId ?? '-'}</Table.Td>
      <Table.Td>{element.workRequestId ?? '-'}</Table.Td>
      <Table.Td>{element.conversationId ?? '-'}</Table.Td>
      <Table.Td>{element.code ?? '-'}</Table.Td>
    </Table.Tr>
  ));

  return (
    <AppShell.Main>
      <Flex align='center' justify='space-between' mb='lg'>
        <Title order={2}>Глобальные события</Title>
      </Flex>

      <Space h='md' />

      {data?.data.items.length === 0 && (
        <Center>
          <Text c='dimmed'>Нет данных для отображения.</Text>
        </Center>
      )}

      {data && (
        <Card withBorder p='lg' radius='md' shadow='sm'>
          <ScrollArea>
            <Table highlightOnHover striped withColumnBorders withTableBorder>
              <Table.Thead
                style={{
                  position: 'sticky',
                  top: 0,
                  background: 'white',
                  zIndex: 1
                }}
              >
                <Table.Tr>
                  <Table.Th>ID</Table.Th>
                  <Table.Th>Тип</Table.Th>
                  <Table.Th>Когда</Table.Th>
                  <Table.Th>Артист (ID)</Table.Th>
                  <Table.Th>Клуб (ID)</Table.Th>
                  <Table.Th>Приглашение (ID)</Table.Th>
                  <Table.Th>Запрос (ID)</Table.Th>
                  <Table.Th>Разговор (ID)</Table.Th>
                  <Table.Th>Код</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>{rows}</Table.Tbody>
            </Table>
          </ScrollArea>

          <Flex justify='center' mt='md'>
            <Pagination
              boundaries={1}
              siblings={1}
              total={data.data.totalPages}
              value={page}
              onChange={setPage}
            />
          </Flex>
        </Card>
      )}
    </AppShell.Main>
  );
};
